<template>
	<section
		class="container container--a margin-module"
		v-if="data && ((loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading')"
	>
		<h2 class="container container--small" v-if="data.module_title" v-html="data.module_title"></h2>
		<div class="inner-content">
			<ul class="people-list" v-if="postItems && postItems.length">
				<template v-for="(person, k) in persons">
					<li :key="k" :class="'item'">
						<PersonBlock :data="person" />
					</li>
				</template>
			</ul>
		</div>
	</section>
</template>

<script>
import { mapActions } from 'vuex'
import PersonBlock from '@/components/parts/PersonBlock'

export default {
	name: 'persons-list',
	props: ['data'],
	data() {
		return {
			showingMoreInfo: false,
			postItems: [],
			loadingPostsStatus: 'loading',
		}
	},
	components: {
		PersonBlock,
	},
	computed: {
		persons() {
			if (this.postItems && this.postItems.length) {
				return this.data.persons.map((e) => {
					e.person_data = this.postItems.find((p) => p.id === e.person)
					return e
				})
			} else {
				return false
			}
		},
		loadOpt() {
			const VM = this
			if (!VM.data) return false
			let opt = {
				type: 'persons',
				include: VM.data.persons.map((p) => p.person),
				limit: VM.data.persons ? VM.data.persons.length : 0,
			}
			//if(VM.data.category) opt.category = VM.data.category.join(',')
			return opt
		},
	},
	mounted() {
		const VM = this
		if (!VM.data) return false
		VM.loadPosts()
	},
	methods: {
		...mapActions(['getPost']),

		loadPosts() {
			const VM = this
			if (!VM.loadOpt) {
				VM.loadingPostsStatus = 'failed'
				return false
			}

			VM.loadingPostsStatus = 'loading'
			return VM.getPost(VM.loadOpt).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					VM.postItems = res.data.posts
				}
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-persons {
	.people-list {
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			margin-bottom: 25px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
